/* tslint:disable */
/* eslint-disable */
export enum AccountHolderType {
  BUSINESS = 'BUSINESS',
  INDIVIDUAL = 'INDIVIDUAL'
}
